import { render, staticRenderFns } from "./LoyaltyPoints.template.vue?vue&type=template&id=4984b5d6&scoped=true&"
var script = {}
import style0 from "./LoyaltyPoints.template.vue?vue&type=style&index=0&id=4984b5d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4984b5d6",
  null
  
)

export default component.exports